import { render, staticRenderFns } from "./addCustomerInvoices.vue?vue&type=template&id=cd4f84fa&scoped=true"
import script from "./addCustomerInvoices.vue?vue&type=script&lang=js"
export * from "./addCustomerInvoices.vue?vue&type=script&lang=js"
import style0 from "./addCustomerInvoices.vue?vue&type=style&index=0&id=cd4f84fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4f84fa",
  null
  
)

export default component.exports